// Function to scroll to the top of the page
export function scrollToTop() {
  // Scroll to top smoothly
  window.scrollTo({
      top: 0,
      behavior: 'smooth'
  });
}

// Function to show/hide the scroll-to-top button based on scroll position
export function initScrollFunction() {
  // Function to handle scrolling and window resizing
  function handleScrollAndResize() {
      var scrollToTopBtn = document.getElementById("scrollToTopBtn");

      // Show the button on mobile devices (screen width <= 767)
      if (window.innerWidth <= 767) {
          if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
              scrollToTopBtn.style.display = "grid";
          } else {
              scrollToTopBtn.style.display = "none";
          }
      } else {
          // Hide the button on desktop devices (screen width > 767)
          scrollToTopBtn.style.display = "none";
      }
  }

  // Initial call to handleScrollAndResize to set button visibility on page load
  handleScrollAndResize();

  // Add event listener for scroll event
  window.addEventListener('scroll', handleScrollAndResize);

  // Add event listener for resize event
  window.addEventListener('resize', handleScrollAndResize);
}
